module.exports = __webpack_public_path__ + "img-front/register/calendar.38784826.svg";